<template>
	<div>
		<HeadNav selectedLanguage="en" page="gb" :gotodownload="gotodownload" :apk="apk" />

		<div class="main-wrapper">
			<hh1>GB WhatsApp Download APK Latest v18.80 | Update 2026</hh1>

			<div class="banner">
				<div class="left">
					<h2>GB WhatsApp App Details</h2>
					<div class="table-wrapper">

						<table>

							<tbody>

								<tr>
									<td>App Name</td>
									<td>GB WhatsApp</td>
								</tr>
								<tr>
									<td>Android Version</td>
									<td>4.3 and Above</td>
								</tr>
								<tr>
									<td>Latest Version</td>
									<td>v18.80</td>
								</tr>
								<tr>
									<td>App Size</td>
									<td>56.55 MB</td>
								</tr>
								<tr>
									<td>Category</td>
									<td>Mod APK</td>
								</tr>
								<tr>
									<td>Total Downloads</td>
									<td>9,000,000 +</td>
								</tr>
								<tr>
									<td>Last Updated</td>
									<td>1 day ago</td>
								</tr>
								<tr>
									<td>License</td>
									<td>Free</td>
								</tr>
							</tbody>
						</table>

					</div>

					<DownloadBtn value="GB WhatsApp Downlaod" />
				</div>

			</div>	
			<article>
				<hh2>Why Choose GB WhatsApp?</hh2>
				<p><a href="https://gbfreeapk.com/"><strong>GB WhatsApp</strong></a> is for users who want more freedom than the standard WhatsApp offers. It adds extra options for privacy, customization, messaging, and media sharing, giving you more control over how the app looks and works.</p>
				<p>If features such as hiding your online status, changing themes, using multiple accounts, or sharing larger files are important to you, GB WhatsApp may be worth trying.</p>
				<my-img src='2' alt='WhatsApp Download' type="heng" />
				<hh2>What is GB WhatsApp APK?</hh2>
				<p><a href="https://gbfreeapk.com/">GB WhatsApp APK</a> is a modified version of WhatsApp for Android. It keeps the familiar messaging experience while adding extra customization and privacy options that are not available in the official app.</p>
				<p>The available features vary between versions, so it is important to check the APK version and update information before downloading.</p>
				<hh2>GB Whatsapp APK Features</hh2>
				<p>You must be curious to know about the advanced features that I'm discussing. Let's enter into the
					world of endless features of <strong>GB WhatsApp update</strong>.</p>

				<div class="area">
					<hh3>Privacy and Security</hh3>
					<p><strong>GB WhatsApp MOD APK</strong> provides an extra layer of security to your conversation.
						You
						can even set privacy for chats, groups, and broadcasts. It empowers you to get full control over
						the
						chat which provides a piece of relaxation to you. Take control of your online presence by hiding
						blue ticks, hiding recording, hiding blue microphones, and hiding typing.</p>
					<my-img src='3' alt='Privacy and Security' />

				</div>
				<div class="area">
					<hh3>Themes Customization</hh3>
					<p><strong>Gb</strong> <strong>whatsapp download 53 mb</strong> has pre-installed themes that can be
						customized according to your preferences. You can customize your theme set using your images and
						colors. Change the color schemes, fonts, background, and chat bubble style. Moreover, to make
						chat
						visuals more appealing you can also customize the themes of each chat in your style. It provides
						great fun to the user now it’s up to you how you play with them.</p>
					<my-img src='4' alt='Themes Customization' />

				</div>
				<div class="area">
					<hh3>Chat Screen Action Bar</hh3>
					<p>Action-bar is also present in this popular messaging app <strong>GB WhatsApp Pro Update</strong>
						that
						you can use to manage the contact and chat appearance. This stunning feature hides the contact’s
						profile picture, name, and even call option. You can also mute notifications of your contact’s
						messages and online status. You can also use these powerful editing tools to customize the
						background of the chat.</p>
					<my-img src='5' alt='Chat Screen Action Bar' />

				</div>
				<div class="area">
					<hh3>App Language</hh3>
					<p>Go to settings and change the default app language to your preferred language. It is helpful for
						those who need to be made aware of the app’s default language. You can choose <strong>Spanish,
							French, German</strong>, and even more.</p>
					<my-img src='6' alt='App Language' />

				</div>
				<div class="area">
					<hh3>Home Screen</hh3>
					<p>All action buttons are present on the home screen like chats, groups, status updates, headers and
						rows, etc. All are performing specific functions like header shows the user’s name, status, and
						profile picture while the hand rows display users’ status updates, chats, and groups.
						Additionally,
						the share option in status allows you to share your status with your contacts directly.</p>

				</div>
				<div class="area">
					<hh3>Chat Screen</hh3>
					<p><strong>GB WhatsApp Pro Latest Version</strong> has several key features for a Chat screen where
						you
						contact people through text, voice, and multimedia messages. Conversational entry style, ticks,
						pics, and action bar are also included in the Chat screen layout. Manage your conversations
						using an
						action bar while bubbles and ticks act as visual indicators. Bubbles and ticks perform the same
						functions in recognizing whether the messages are sent, delivered, or read. Customize
						conversation
						entry style when you write a text and with the help of the pics feature send bulk pics to your
						contacts.</p>
					<my-img src='7' alt='Chat Screen' />

				</div>
				<div class="area">
					<hh3>Universal Settings</hh3>
					<p>Universal settings help in customizing colors, styles, backups, and restores. These settings
						change
						the look of the <strong>GB WhatsApp download 53 mb</strong> to provide amazing feelings to the
						users. Another layer of privacy is you can hide your chat media from gallery items. It makes
						your
						chats more secure.</p>
					<my-img src='8' alt='Universal Settings' />

				</div>
				<div class="area">
					<hh3>Notification of Being Online</hh3>
					<p>You can turn off your online notifications thus no one will be able to see your activeness in the
						app. Moreover, users can individually set privacy to which they want to show their online
						status.
					</p>
					<my-img src='9' alt='Notification of Being Online' />

				</div>
				<div class="area">
					<hh3>DND Mode</hh3>
					<p><strong>DND</strong> stands for Do Not Disturb Mode, you can open it when you are doing important
						work and spending time with your family. It protects your battery life and you can manually turn
						it
						on/off.</p>

				</div>
				<div class="area">
					<hh3>Filter Settings</hh3>
					<p>Use <strong>GB WhatsApp download APK</strong> filter settings and easily filter out your
						important
						messages using unread stars or attachments. In this way, you can save time and energy and get
						quick
						access to your messages.</p>

				</div>
				<div class="area">
					<hh3>Download Media (Status, Videos, Images, Stories</hh3>
					<p><strong>Whatsapp GB MOD APK</strong> also has another prominent feature of downloading status,
						videos, images, and stories from any contact or group. Download beautiful videos, eye-catching
						images, inspiring stories, and funny clips with just a single tap.</p>

				</div>
				<div class="area">
					<hh3>App Lock</hh3>
					<p>Lock your <strong>GB WhatsApp download 53MB</strong> to save your data using a password and
						fingerprint option. It will save your data from any user or from those who can access it in an
						unauthorized way. It gives the owner some peace of mind that their details are safe.</p>

				</div>
				<div class="area">
					<hh3>Auto-reply</hh3>
					<p>Just imagine you are in a meeting and someone is messaging you and you can’t respond then set
						customized auto reply for it. You can set this feature for individual chats or groups as well.
					</p>

				</div>
				<div class="area">
					<hh3>Message Scheduler</hh3>
					<p>Everyone is busy in their lives so to save time and effort you can schedule your messages like
						wishing a birthday to someone and setting a reminder of important messages.</p>

				</div>
				<div class="area">
					<hh3>Share Live Location</hh3>
					<p>Use <strong>gb</strong> <strong>whatsapp apk 13.50 download</strong> and share your live
						locations
						with your friends and family members. It will also show your estimated arrival time when you are
						far
						away from any place. You just need to tap on the share location option and real-location will be
						shared automatically.</p>

				</div>
				<div class="area">
					<hh3>People Nearby</hh3>
					<p>To become more social use <strong>GB WhatsApp pro Fouad mods</strong> “People Nearby” feature to
						connect with new people and expand your social community.You can also see their profile picture,
						username, and status and chat with them.</p>

				</div>
				<div class="area">
					<hh3>Emoji Effect</hh3>
					<p>I love this because I can make my message’s visuals more appealing by adding emojis, stickers,
						animations, and sparkles to them. Now, you can use this dynamic feature to react to jokes, show
						expressions, and give compliments.</p>

				</div>
				<div class="area">
					<hh3>Anti ban</hh3>
					<p>Some people are worried about whether their accounts get banned while using this app or not.
						<strong>GBWhatsApp pro APK</strong> <strong>file</strong> has its premium feature anti-ban that
						ensures a secure messaging platform and following its terms and conditions saves the users from
						getting banned. Thus, you can use it without interruption and security issues.
					</p>

				</div>
				<div class="area">
					<hh3>Hide Your Status Seen</hh3>
					<p>Another interesting feature is that if you have viewed someone’s status then you can enable your
						hide
						your status seen options that will be not visible to the respected member. Thus, no one can know
						whether you have seen their status or not.</p>

				</div>
				<div class="area">
					<hh3>Profile Picture</hh3>
					<p>With <strong>WhatsApp</strong> <strong>MOD</strong> <strong>APK Pro</strong> you can set your
						profile
						picture that be visible to your contacts in the chat or contact section.</p>

				</div>
				<div class="area">
					<hh3>Anti-Delete Messages and Status</hh3>
					<p><strong>GB WhatsApp download for android</strong> has another premium feature anti-delete
						messages
						and status. It prevents the loss of important messages or status if someone has deleted and
						keeps a
						data record.</p>

				</div>
				<div class="area">
					<hh3>Send Multiple Pictures</hh3>
					<p>Simple WhatsApp doesn’t allow you to send multiple pictures at once but <strong>WhatsApp</strong>
						<strong>GB</strong> <strong>download</strong> has these standout features. While sending bulk
						pictures it also doesn’t compromise on quality. So, send multiple images without any limit and
						in
						<strong>HD</strong> <strong>quality</strong>.
					</p>

				</div>
				<div class="area">
					<hh3>Notification and Launcher Icons</hh3>
					<p>You can customize your app to your style. It has several notifications and launcher icons that
						you
						can change according to your interest and enhance your <strong>GB WhatsApp pro features</strong>
						experience.You can turn off your online notifications thus no one will be able to see your
						activeness in the app. Moreover, users can individually set privacy to which they want to show
						their
						<strong>online status</strong>.
					</p>

				</div>
				<div class="area">
					<hh3><a href="/unread-messages-in-gbwhatsapp/" class="jump-url">Unread Message</a> Counter</hh3>
					<p><strong>GB WhatsApp pro</strong> <strong>FM</strong> has the incredible feature of an unread
						message
						counter. It organize these messages and they will be visible at the top of communication.</p>

				</div>
				<div class="area">
					<hh3>Multiple Accounts</hh3>
					<p>Now, users must think they have to delete the old WhatsApp to install the mod version of
						<strong>gb</strong> <strong>whatsapp download apk</strong>. That’s not the case you can use
						multiple
						accounts on a single device.
					</p>

				</div>
				<div class="area">
					<hh3>Upload Long Status</hh3>
					<p>In simple <strong>WhatsApp</strong>, you upload the status of limited characters but here you can
						upload a long status. This is a most engaging feature for status-uploading lovers especially me.
					</p>


				</div>




				<hh2>Requirements to Install GB Whatsapp MOD APK</hh2>
				<p>As you are going to run this app on your Android device it needs some requirements for an
					operating
					system. Your device must be <strong>Android 4.0.3 or later</strong>. You must have enough
					storage on
					your device to install the app. To download the app you need an internet connection, ensure your
					mobile is connected to the internet.</p>
				<my-img src='10' alt='Requirements to Install GB Whatsapp MOD APK' type="heng" />
				<hh2>How to Download GB WhatsApp Pro APK?</hh2>
				<p>When these requirements are fulfilled the next step is to download the Latest Version of <strong>gb
						whatsapp free download</strong>. Follow the below steps to download it:</p>
				<p><strong>Step 1:</strong> Open our most trustworthy site and find the download button present on the
					top.</p>
				<p><strong>Step 2:</strong> Tap on the download button and wait until the file gets downloaded.</p>
				<p><strong>Step 3:</strong> After downloading, click on the file to install it.</p>
				<p><strong>Step 4:</strong> Wait for the installation process to complete.</p>
				<p><strong>Step 5:</strong> Now open <strong>WhatsApp Pro Green</strong> and start using it.</p>
				<hh2>How to Install GB WhatsApp APK on Android</hh2>
				<p>Some users face issues while installing the app. Follow these steps for a smooth installation:</p>
				<ol>
					<li>Click the button to download the file.</li>
					<li>Go to your device’s <strong>Settings &gt; Security</strong> and enable <strong>Unknown
							Sources</strong>.</li>
					<li>Open the downloaded file and tap <strong>Install</strong>.</li>
					<li>Wait a few moments for the installation to finish.</li>
					<li>Launch GB WhatsApp, verify your phone number, and start exploring its features.</li>
				</ol>
				<hh2>Comparison Between Simple Whatsapp and GB Whatsapp</hh2>
				<table>
					<thead>
						<tr>
							<th>Features</th>
							<th>GB Whatsapp Pro</th>
							<th>Simple Whatsapp</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>Home screen status</td>
							<td>Yes</td>
							<td>No</td>
						</tr>
						<tr>
							<td>Custom Fonts and stickers</td>
							<td>Yes</td>
							<td>No</td>
						</tr>
						<tr>
							<td>Home screen Name</td>
							<td>Yes</td>
							<td>No</td>
						</tr>
						<tr>
							<td>Status Download</td>
							<td>Yes</td>
							<td>No</td>
						</tr>
						<tr>
							<td>Home Screen Story Style</td>
							<td>Yes</td>
							<td>No</td>
						</tr>
						<tr>
							<td>Themes store</td>
							<td>Yes</td>
							<td>No</td>
						</tr>
						<tr>
							<td>Hidden Chats under the name</td>
							<td>Yes</td>
							<td>No</td>
						</tr>
						<tr>
							<td>DND Mode</td>
							<td>Yes</td>
							<td>No</td>
						</tr>
						<tr>
							<td>Auto Messages</td>
							<td>Yes</td>
							<td>No</td>
						</tr>
						<tr>
							<td>Bulk Messages</td>
							<td>Yes</td>
							<td>No</td>
						</tr>
						<tr>
							<td>File Sending Limits</td>
							<td>1000 MB</td>
							<td>100 MB</td>
						</tr>
						<tr>
							<td>Image Share Limit</td>
							<td>100 MB</td>
							<td>30 MB</td>
						</tr>
						<tr>
							<td>Forwarding Limit</td>
							<td>Unlimited Chats</td>
							<td>5</td>
						</tr>
						<tr>
							<td>Themes</td>
							<td>Yes</td>
							<td>No</td>
						</tr>
						<tr>
							<td>Online Status</td>
							<td>Yes</td>
							<td>Yes</td>
						</tr>
						<tr>
							<td>Freeze last seen</td>
							<td>Yes</td>
							<td>Yes</td>
						</tr>
						<tr>
							<td>Disable Forward Tag</td>
							<td>Yes</td>
							<td>No</td>
						</tr>
						<tr>
							<td>Disable Customize Calling</td>
							<td>Yes</td>
							<td>No</td>
						</tr>
						<tr>
							<td>Anti-Delete</td>
							<td>Yes</td>
							<td>No</td>
						</tr>
						<tr>
							<td>Auto Reply</td>
							<td>Yes</td>
							<td>No</td>
						</tr>
						<tr>
							<td>Security Lock</td>
							<td>Yes</td>
							<td>No</td>
						</tr>
					</tbody>
				</table>
				<hh2>What's New in GB WhatsApp Download</hh2>
				<ul>
					<li>Extended status character limit</li>
					<li>Add custom fonts and stickers</li>
					<li>Disable “Forwarded” tag</li>
					<li>Auto-reply feature</li>
					<li>Large media file sharing</li>
					<li>DND (Do Not Disturb) Mode</li>
				</ul>
				<hh2>GB WhatsApp for iOS</hh2>
				<p>The latest version of GB WhatsApp for iOS is now compatible with iPhone, iOS, and PC devices. iPhone
					users can enjoy the same features as Android users.</p>
				<p><strong>Steps to</strong> <strong>Install</strong> <strong>GB WhatsApp on iOS:</strong></p>
				<ol>
					<li>Open the browser on your iPhone.</li>
					<li>Visit our site and tap the <strong>Download</strong> button.</li>
					<li>Once downloaded, tap to <strong>Install</strong>.</li>
					<li>Wait for installation to complete.</li>
					<li>Launch GB WhatsApp and log in with your account.</li>
				</ol>
				<hh2>GB WhatsApp for PC</hh2>
				<p>Like iOS, you can also run <strong>GB WhatsApp Download APK</strong> on your PC with the help of an
					Android emulator like <strong>Bluestacks</strong> or <strong>NoxPlayer</strong>. This allows you to
					enjoy all features on a bigger screen.</p>
				<p><strong>Steps to</strong> <strong>Install</strong> <strong>GB</strong> <strong>WhatsApp on
						PC:</strong></p>
				<ol>
					<li>Download and install an emulator (e.g., Bluestacks).</li>
					<li>Sign in to the emulator with your account.</li>
					<li>Import or search for the <strong>GB WhatsApp APK file</strong>.</li>
					<li>Click <strong>Install</strong> <strong>APK</strong> and wait for setup to complete.</li>
					<li>Open GB WhatsApp in the emulator drawer and start using it.</li>
				</ol>
				<hh2>How to Connect GB WhatsApp to Web Using QR Code</hh2>
				<ol>
					<li>Open <strong>GB WhatsApp</strong> on your phone.</li>
					<li>Go to the <strong>QR Code</strong> <strong>Scan</strong> option.</li>
					<li>On your PC, open <strong>GB WhatsApp Web</strong>.</li>
					<li>Use your phone camera to scan the QR code.</li>
					<li>All chats and media will sync instantly to your PC.</li>
				</ol>
				<hh2>Benefits of GB WhatsApp Latest Version</hh2>
				<ul>
					<li>Customizable themes and fonts</li>
					<li>Enhanced privacy: hide online status, blue ticks, and anti-revoke messages</li>
					<li>Auto-reply and message scheduling</li>
					<li>Live location sharing</li>
					<li>Send larger videos and longer status updates</li>
				</ul>
				<hh2>Pros and Cons of GB WhatsApp APK</hh2>
				<p><strong>Pros</strong></p>
				<ul>
					<li>Improved performance with the latest version</li>
					<li>Stay connected with family, friends, and coworkers</li>
					<li>Share large videos, images, and files</li>
					<li>Full customization for themes and chat interface</li>
				</ul>
				<p><strong>Cons</strong></p>
				<ul>
					<li>Should not be used for spam or illegal activities</li>
					<li>Sharing copyrighted or unauthorized content is discouraged</li>
				</ul>
				<hh2>GB WhatsApp Backup &amp; Update Guide</hh2>
				<p>Before installing or switching to a new version, securing your data is essential. Whether you’re
					using the latest release or an <strong>Old Version GB WhatsApp Download</strong>, backing up ensures
					your chats and media remain safe. Here are two simple methods:</p>
				<p><strong>Method 1: Backup Within the App</strong></p>
				<ul>
					<li>Open GB WhatsApp and go to <strong>Settings</strong>.</li>
					<li>Tap <strong>Chats &gt; Chat Backup</strong>.</li>
					<li>A copy of your messages, photos, and videos will be saved to your device storage.</li>
				</ul>
				<p><strong>Method 2: Backup with Computer Software</strong> If you’re running <strong>GB WhatsApp APK
						Download</strong> on PC via an emulator, you can use tools like <strong>Dr.Fone – Restore Social
						App</strong> to back up, transfer, and restore your data. This includes voice notes, images,
					documents, and more, all managed through a simple interface.</p>
				<hh2>How to Update GB WhatsApp APK</hh2>
				<p>GB WhatsApp is updated regularly to bring new features and bug fixes. To update manually:</p>
				<ol>
					<li>Open <strong>GB</strong> <strong>WhatsApp</strong>, tap the <strong>Menu</strong>, and go to
						<strong>Settings</strong>.
					</li>
					<li>Select <strong>Update</strong> and download the latest version.</li>
					<li>Wait for the process to complete.</li>
					<li>The app will restart automatically with all new features unlocked.</li>
				</ol>
				<p>Now you're ready to enjoy the most up-to-date GB WhatsApp with enhanced performance and security.</p>
				<hh2>Conclusion</hh2>
				<p>In conclusion, <strong>GB WhatsApp Download</strong> has become one of the most popular choices for
					users who want advanced features beyond the official WhatsApp. With its privacy controls,
					customization options, and multi-device flexibility, it’s no surprise that people are eager to get
					the modified version on their phones.</p>
				<p>I’ve outlined the complete steps on how to <strong>GB WhatsApp Download</strong> and install it on
					Android, as well as how to use it on PC to stay connected with friends and family. Simply click the
					download button, follow the installation guide, and transfer your chats from regular WhatsApp to GB
					WhatsApp Pro or even older versions if needed.</p>
				<hh2>FAQs</hh2>
				<FAQ :faqs="faqs" />
			</article>

		</div>
		<DownloadBtn value="GB WhatsApp Downlaod" mg="1"
			style="position: fixed;bottom: 10px;transform: translateX(-50%);left: 50%;white-space: nowrap;"
			v-if="$global.isMobileDevice()" />
	</div>
</template>

<script>
import '@/css/base.scss'
import '@/css/index.scss'
import HeadNav from '@/components/HeadNav.vue'
import DownloadBtn from '../components/DownloadBtn.vue'
import FAQ from '../components/FAQ.vue'
export default {
	name: 'Home',
	components: {
		HeadNav,
		DownloadBtn,
		FAQ,
	},
	data() {
		return {
			faqs: [
				{
					question: "What is GB WhatsApp APK?",
					answer: "GB WhatsApp is a modified version of the official WhatsApp with extra features like privacy control, customization, and dual account support."
				},
				{
					question: "Is GB WhatsApp safe to use?",
					answer: "It is developed by third-party modders, not official WhatsApp. While it offers advanced features, it may pose security and ban risks."
				},
				{
					question: "How do I install GB WhatsApp on Android?",
					answer: "Download the APK file, enable installation from unknown sources in your settings, then install it like any other app."
				},
				{
					question: "Can I use GB WhatsApp on iPhone?",
					answer: "No. GB WhatsApp APK is only compatible with Android devices."
				},
				{
					question: "Will my WhatsApp account get banned for using GB WhatsApp?",
					answer: "There is always a small risk of temporary or permanent bans, though the anti-ban feature reduces it."
				},
				{
					question: "Can I transfer my chats from WhatsApp to GB WhatsApp?",
					answer: "Yes, you can move your data by copying the WhatsApp folder to the GBWhatsApp folder before installation."
				},
				{
					question: "Does GB WhatsApp support dual accounts?",
					answer: "Yes, you can use GB WhatsApp alongside official WhatsApp to run two accounts on the same phone."
				},
				{
					question: "Can I download statuses directly?",
					answer: "Yes, GB WhatsApp has a built-in status downloader to save photos and videos."
				},
				{
					question: "Does GB WhatsApp have ads?",
					answer: "Most versions are ad-free, but some modified builds may include ads depending on the developer."
				},
				{
					question: "What are the best alternatives to GB WhatsApp?",
					answer: "Popular alternatives include WhatsApp Plus, OG WhatsApp, FM WhatsApp, and YoWhatsApp."
				}
			],
			pageName: 'home',
			tableHide: true,
			comment: {
				name: '',
				email: '',
				content: '',
			},
			showapk: false,
			showTableOfContents: false,

			apk: null,
			from: 'gb',
			filename: 'gb',
			clickNum: 0,
			selectedLanguage: 'en',
			lang: [
				{
					lang: 'en',
					val: '🇺🇸 English',
				},
				{
					lang: 'ar',
					val: '🇦🇪 اَلْعَرَبِيَّةُ',
				},
				{
					lang: 'id',
					val: '🇮🇩 Bahasa Indonesia',
				},
				{
					lang: 'pt',
					val: '🇵🇹 Português',
				},
				{
					lang: 'es',
					val: '🇪🇸 Español',
				},
				{
					lang: 'hi',
					val: '🇮🇳 हिंदी',
				},
			],

			androidSrc: require('@/assets/android.svg'),
			androidSrc2: require('@/assets/android.svg'),

		}
	},
	computed: {
		downloadURL() {
			// var params = window.location.search;
			// return `/gbwhatsapp-apk-download${params}`;
			if (typeof window === 'undefined') {
				// Server-side rendering logic
				return '/gbwhatsapp-apk-download' // Adjust this based on your server-side logic
			} else {
				// Client-side rendering logic
				let params = window.location.search
				return `/gbwhatsapp-apk-download${params}`
			}
		},
	},
	mounted() {
		this.from = this.$global.GetQueryString('from') || this.from
		this.filename = this.$global.GetQueryString('filename') || this.filename
		console.log(this.$global.GetQueryString('from'))
		if (this.$global.GetQueryString('from')) {
			this.getAPK()
		} else {
			this.getOfficalApk()
		}



		// window.adsTag.renderInterstitial(54982);
	},
	methods: {
		changeImage(newImage) {
			this.androidSrc = require(`@/assets/${newImage}`)
		},
		changeImage2(newImage) {
			this.androidSrc2 = require(`@/assets/${newImage}`)
		},
		changeLanguage(lang) {
			console.log(lang)
			// 处理语言选择变化
			// 这里可以添加其他处理逻辑，例如将语言保存到cookie或localStorage中
			this.$router.push({
				name: `${this.selectedLanguage}-gb`,
			})
		},
		downloadClick() {
			this.$router.push({
				name: 'en-download',
			})
		},
		getAPK() {
			this.$server
				.getAPPInfo({
					promotionChannel: this.from,
					promotionName: this.filename,
				})
				.then((res) => {
					console.log(res)
					if (res.code == 200) {
						this.apk = res.data.apk
					} else {
						this.apk = process.env.VUE_APP_GBLINK
					}
				})
		},
		getOfficalApk(type = 1, domain = null, appname = null) {
			this.$server
				.getOfficalApk({
					domain: domain || 'gbwhatsapp.chat',
					appName: appname || 'GB_gbwhatsapp.chat',
				})
				.then((res) => {
					console.log(res)
					if (res.code == 200) {
						if (type == 1) {
							this.apk = res.data.apk
						}
						this.lastupdate = res.data.promotion.updateTime
						this.votes = res.data.promotion.totalCount
						this.rating = res.data.promotion.score
						console.log('apk getted')
					} else {
						this.apk = process.env.VUE_APP_GBLINK
					}
				})
		},
		gotodownload() {
			this.$router.push('/download')
		},
		gotoblog() {
			window.location.href = '/blogs'
		},
		jump(url) {
			window.location.href = url
		},
		toggleTableOfContents() {
			this.showTableOfContents = !this.showTableOfContents
		},
		initSwiper() {
			new Swiper('.swiper-container', {
				slidesPerView: 1,
				spaceBetween: 30,
				loop: true,
				autoplay: {
					delay: 3000,
					disableOnInteraction: false,
				},
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				breakpoints: {
					768: {
						slidesPerView: 2,
						spaceBetween: 20,
					},
					1024: {
						slidesPerView: 3,
						spaceBetween: 30,
					},
				},
			})
		},
	},
}
</script>

<style lang="scss" scoped>
@media screen and (orientation: portrait) {
	.banner {
		flex-direction: column-reverse;
		text-align: center;
	}
}

/* --- 表格基础 --- */
table {
	width: 100%;
	border-collapse: collapse;
	margin: 25px 0;
	font-size: 16px;
	text-align: left;
	border-radius: 12px;
	overflow: hidden;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

/* --- 表头 --- */
table thead {
	background-color: #25b864;
	color: #fff;
	font-weight: 600;
}

table thead th {
	padding: 14px 18px;
	border-bottom: 2px solid rgba(255, 255, 255, 0.1);
}

/* --- 表格内容 --- */
table tbody tr {
	background-color: #fff;
	transition: background-color 0.25s ease;
}

table tbody tr:nth-child(even) {
	background-color: #f8fdf9;
	/* 柔和浅绿间隔行 */
}

table tbody tr:hover {
	background-color: #eaf9f0;
	/* hover 时高亮 */
}

/* --- 单元格 --- */
table td {
	padding: 12px 18px;
	border-bottom: 1px solid #e0e0e0;
	color: #333;
	line-height: 1.6;
	font-weight: 600;
}

/* --- 响应式滚动 --- */
.table-wrapper {
	overflow-x: auto;
	border-radius: 12px;
	width: 100%;
}

/* --- 小屏优化 --- */
@media (max-width: 768px) {
	table {
		font-size: 14px;
	}

	table thead th,
	table td {
		padding: 10px 12px;
	}
}


.banner {
	display: flex;
	justify-content: space-between;
	align-items: center;
	background: #f5f5f5;
	padding: 20px;
	border-radius: 10px;
	margin-top: 20px;
	border-color: #25b864;
	border-width: 2px;
	border-style: solid;

	h2 {
		color: #333;
	}

	.left {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;

		h2 {
			margin-bottom: 10px;
		}

		table {
			width: 100%;
			border-collapse: collapse;
			margin-bottom: 20px;

			th,
			td {
				border: 1px solid #ddd;
				padding: 8px;
				text-align: left;
			}

			th {
				background-color: #f2f2f2;
			}
		}
	}




}


/* 每个 hh3 + 内容的包裹区域 */
article a {
	color: #1a5881;
	text-decoration: underline;
	text-underline-offset: 2px;
}

article a:hover,
article a:focus {
	color: #2880ba;
	text-decoration: underline;
}

.area {
	background-color: #f5f9f8;
	/* 淡淡的科技风背景色，和页面整体柔和搭配 */
	border-left: 4px solid #25b864;
	/* 与 h2 主色呼应 */
	padding: 20px 25px;
	margin: 20px 0;
	border-radius: 12px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
	transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.area:hover {
	transform: translateY(-2px);
	box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}

.area hh3 {
	font-size: 20px;
	font-weight: 600;
	color: #25b864;
	/* 和 h2 主题色统一 */
	margin-bottom: 12px;
}

.area p {
	color: #333;
	/* 文字清晰 */
	line-height: 1.7;
	margin-bottom: 12px;
}

.area my-img {
	display: block;
	max-width: 100%;
	height: auto;
	margin: 12px 0;
	border-radius: 8px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
</style>
